<div class="legend">
  <h3>{{header}}</h3>
  <div class="legend-items">
    <div *ngFor="let item of items">
      <div class="color" [style.backgroundColor]="item.color"></div>
      <p>{{item.description}}</p>
    </div>
  </div>
</div>
